import {
  BlockStack,
  Box,
  Card,
  Layout,
  Link,
  Page,
  Text,
} from "@shopify/polaris";
import { useQuery } from "@tanstack/react-query";

import { getMe } from "../api/me";
import { currentLocale, t } from "../lib/i18n";

const SUPPORT_EMAIL = "support@ureyukibox.app";

const SUPPORT_PHONES = {
  ja: { display: "(+81)5068645901", href: "+815068645901" },
  en: { display: "+14155488185", href: "+14155488185" },
} as const;

export function Contact() {
  const meQuery = useQuery({ queryKey: ["me"], queryFn: getMe });
  // The direct phone promise belongs only to an authoritative ACTIVE Business
  // subscription. Loading, failed, inactive, or unknown plan data fails closed.
  const isBusiness =
    meQuery.isSuccess &&
    meQuery.data.subscription.active === true &&
    meQuery.data.subscription.plan_code === "business";
  const phone = SUPPORT_PHONES[currentLocale() === "ja" ? "ja" : "en"];

  return (
    <Page title={t("お問い合わせ")}>
      <Layout>
        {isBusiness && (
          <Layout.Section>
            <Card>
              <BlockStack gap="400">
                <BlockStack gap="200">
                  <Text as="h2" variant="headingLg">
                    {t("問題がございましたら、お電話ください")}
                  </Text>
                  <Text as="p" variant="bodyMd" tone="subdued">
                    {t("UreyukiBox の操作や Stocky 移行についてお困りの点をお伺いします。")}
                  </Text>
                </BlockStack>
                <Box>
                  <Text as="p" variant="heading2xl">
                    <Link url={`tel:${phone.href}`}>{phone.display}</Link>
                  </Text>
                </Box>
              </BlockStack>
            </Card>
          </Layout.Section>
        )}

        <Layout.Section>
          <Card>
            <BlockStack gap="300">
              <Text as="h2" variant="headingMd">
                {t("メールでのお問い合わせ")}
              </Text>
              <Text as="p" variant="bodyMd">
                <Link url={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
              </Text>
              <Text as="p" variant="bodyMd" tone="subdued">
                {t("ストアの URL と、できれば表示されたエラー内容を添えていただくと、確認がスムーズです。")}
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
